import { useQuery } from "@tanstack/react-query";
import { getRedmineUsers } from "../api/adminApi";
import { adminKeys } from "../api/adminKeys";

// Lista de colaboradores de Redmine para el selector de admin.
export const useRedmineUsers = () =>
  useQuery({
    queryKey: adminKeys.redmineUsers(),
    queryFn: getRedmineUsers,
  });
